import api from '@/api/index.js'

const account_stats = {
  state: {
    loading: false,
    data: null,
    error: null,
  },

  mutations: {
    SET_ACCOUNT_STATS_LOADING: (state, loading) => {
      state.loading = loading
    },
    SET_ACCOUNT_STATS: (state, account) => {
      state.data = account
      state.loading = false
    },
    SET_ACCOUNT_STATS_ERROR: (state, error) => {
      state.error = error
      state.loading = false
    }
  },

  actions: {
    LoadAccountsStats({commit}) {
      commit('SET_ACCOUNT_STATS_ERROR', null)
      commit('SET_ACCOUNT_STATS_LOADING', true)
      return api.get(`stats/accounts`)
        .then((response) => {
          commit('SET_ACCOUNT_STATS', response)
        })
        .catch((error) => {
          commit('SET_ACCOUNT_STATS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
        })
    },
  },
}

export default account_stats
